module.exports = __webpack_public_path__ + "assets/img/advantage-item4.ac847a2a.png";